import { ConfigProps, Product, ProductListConfig } from "../types/types";
import * as layouts from "./";
import React from "react";

type Layout = (props: {
  product: Product;
  config: ProductListConfig;
  configProps: ConfigProps;
  index: number;
}) => React.ReactNode;

type LayoutMap = { [name: string]: Layout };

export const layoutMap: LayoutMap = layouts;
